import Vue from "vue";
import store from "@/store";

import mAnalytics from "@/modules/analytics";
import mApp from "@/modules/app";
import mOrder from "@/modules/order";

import { APP_MODE } from "@/modules/enums";

export default {
  emailSignUp(payload) {
    let loginName = payload.loginName;
    let loginPassword = payload.loginPassword;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberauth", {
        sessionKey: store.getters.serviceSessionKey,
        signup: {
          LoginName: loginName,
          LoginPassword: loginPassword,
          MemberEMail: loginName,
          //AddCard: store.getters.newMemberAddCard,
          //CardPrefix: store.getters.newCardPrefix,
        },
      })
      .then(data => {
        let respSignup = data.signup;
        if (respSignup && respSignup.result == "ok") {
          store.commit("member", respSignup.record);
          mOrder.updateOrderMember();

          mAnalytics.logSignUp("email");
        }
        return respSignup;
      });
  },

  emailLogIn(payload) {
    let loginName = payload.loginName;
    let loginPassword = payload.loginPassword;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberauth", {
        sessionKey: store.getters.serviceSessionKey,
        login: {
          LoginName: loginName,
          LoginPassword: loginPassword,
        },
      })
      .then(data => {
        let respLogin = data.login;
        if (respLogin && respLogin.result == "ok") {
          store.commit("member", respLogin.record);
        }
        return respLogin;
      });
  },

  logout() {
    store.commit("member", null);
    store.commit("giftcards", []);
  },

  setLastLogin(lastLogin) {
    return new Promise(function (resolve) {
      if (store.getters.storageKey == null) {
        resolve(false);
        return;
      }
      
      let key = "LOC_" + store.getters.storageKey;
      Vue.prototype.$idb.setting
        .put({ name: key, value: lastLogin })
        .then(() => {
          resolve(true);
        })
        .catch(error => {
          console.log("setLastLogin catched", error);
          resolve(false);
        });
    });
  },

  getInfo() {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        getInfo: {},
      })
      .then(data => {
        let resp = data.getInfo;
        return resp;
      });
  },

  findMember(payload) {
    if (payload == null || (payload.memberCode == null && payload.phoneId == null && payload.email == null))
      return new Promise(function (resolve) {
        resolve({ result: "No member key provided" });
      });

    return mApp
      .apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        get: {
          MemberCode: payload.memberCode,
          PhoneId: payload.phoneId,
          MemberEMail: payload.email,
          Merchants: true,
        },
      })
      .then(data => {
        let respGet = data.get;

        return respGet;
      });
  },

  getMember(payload) {
    if (payload == null || (payload.memberCode == null && payload.phoneId == null && payload.email == null))
      return new Promise(function (resolve) {
        resolve({ result: "No member code or phone provided" });
      });

    return mApp
      .apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        get: {
          MemberCode: payload.memberCode,
          PhoneId: payload.phoneId,
          MemberEMail: payload.email,
          AutoCreation: payload.autoCreation,
          //AddCard: store.getters.newMemberAddCard,
          //CardPrefix: store.getters.newCardPrefix,
          Merchants: true,
        },
      })
      .then(data => {
        let respGet = data.get;
        if (respGet && respGet.result == "ok") {
          let onhold = respGet.record?.MemberOnhold == true;
          let expired = respGet.record?.Exdata?.expired == true;
          if (onhold) {
            respGet.result = "Your membership is onhold.";
          } else if (expired) {
            respGet.result = "Your membership has expired.";
          } else {
            store.commit("member", respGet.record);

            if (respGet.new) mAnalytics.logSignUp("phone");
          }
        }

        return respGet;
      });
  },

  addMember(member) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        add: {
          MemberLastName: member.MemberLastName,
          MemberFirstName: member.MemberFirstName,
          MemberEMail: member.MemberEMail,
          PhoneId: member.PhoneId,
          PhoneConfirmed: member.PhoneConfirmed,
          EmailVerified: member.EmailVerified,
          MonthOfBirth: member.MonthOfBirth,
          DayOfBirth: member.DayOfBirth,
          YearOfBirth: member.YearOfBirth,
          SmsPromo: member == null ? undefined : member.SmsPromo,
          MemberAddress: {
            AddrPhone1: member.MemberAddress ? member.MemberAddress.AddrPhone1 : undefined,
          },
        },
      })
      .then(data => {
        return data.add;
      });
  },

  putMember(member) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        put: {
          MemberCode: member.MemberCode,
          MemberLastName: member.MemberLastName,
          MemberFirstName: member.MemberFirstName,
          MemberEMail: member.MemberEMail,
          PhoneId: member.PhoneId,
          PhoneConfirmed: member.PhoneConfirmed,
          EmailVerified: member.EmailVerified,
          MonthOfBirth: member.MonthOfBirth,
          DayOfBirth: member.DayOfBirth,
          YearOfBirth: member.YearOfBirth,
          SmsPromo: member == null ? undefined : member.SmsPromo,
          MemberAddress: {
            AddrPhone1: member.MemberAddress ? member.MemberAddress.AddrPhone1 : undefined,
          },
        },
      })
      .then(data => {
        if (data?.put.result == "ok") {
          store.commit("member", member);
        }
        return data.put;
      });
  },

  removeMember() {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        put: {
          MemberCode: store.getters.memberCode,
          MemberActive: false,
        },
      })
      .then(data => {
        return data.put;
      });
  },

  async mergeMember(payload) {
    if (payload == null || (payload.memberCode == null && payload.phoneId == null))
      return new Promise(function (resolve) {
        resolve({ result: "No member code or phone provided" });
      });

    let memberCode = payload.memberCode;
    if (memberCode == null) {
      let resp = await mApp.apiPost(store.getters.dcApiUrl + "/membership", {
        sessionKey: store.getters.serviceSessionKey,
        get: {
          PhoneId: payload.phoneId,
        },
      });

      if (resp && resp.get && resp.get.result == "ok") {
        let getRecord = resp.get.record;
        memberCode = getRecord.MemberCode;
      }
    }

    if (memberCode == null)
      return new Promise(function (resolve) {
        resolve({ result: "Phone number not found" });
      });

    return mApp
      .apiPost(store.getters.dcApiUrl + "/membertransfer", {
        sessionKey: store.getters.serviceSessionKey,
        MemberCode: store.getters.memberCode,
        ClosingMemberCode: memberCode,
      })
      .then(data => {
        return data;
      });
  },

  verifyPhone(phoneId) {
    let n_sessionKey = store.state.appSessionKey;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_sessionKey = store.state.Store.store.sessionKey;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/otp", {
        sessionKey: n_sessionKey,
        send: { phone: phoneId },
      })
      .then(data => {
        return data;
      });
  },

  validatePhone(phoneId, code, token) {
    let n_sessionKey = store.state.appSessionKey;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_sessionKey = store.state.Store.store.sessionKey;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/otp", {
        sessionKey: n_sessionKey,
        validate: { phone: phoneId, token: token, code: code },
      })
      .then(data => {
        return data;
      });
  },

  verifyEmail(email) {
    let n_sessionKey = store.state.appSessionKey;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_sessionKey = store.state.Store.store.sessionKey;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/otp", {
        sessionKey: n_sessionKey,
        send: { email: email },
      })
      .then(data => {
        return data;
      });
  },

  validateEmail(email, code, token) {
    let n_sessionKey = store.state.appSessionKey;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_sessionKey = store.state.Store.store.sessionKey;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/otp", {
        sessionKey: n_sessionKey,
        validate: { email: email, token: token, code: code },
      })
      .then(data => {
        return data;
      });
  },

  addFavoriteStore(favStore) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberFavoriteStore", {
        sessionKey: store.getters.serviceSessionKey,
        add: {
          memberCode: store.getters.memberCode,
          companyCode: favStore,
        },
      })
      .then(data => {
        let dataAdd = data.add;
        if (dataAdd.result == "ok") {
          store.commit("memberFavoriteStores", dataAdd.favoriteStores);
        }
        return dataAdd;
      });
  },

  removeFavoriteStore(favStore) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberFavoriteStore", {
        sessionKey: store.getters.serviceSessionKey,
        remove: {
          memberCode: store.getters.memberCode,
          companyCode: favStore,
        },
      })
      .then(data => {
        let dataRemove = data.remove;
        if (dataRemove.result == "ok") {
          store.commit("memberFavoriteStores", dataRemove.favoriteStores);
        }
        return dataRemove;
      });
  },

  // gift card
  getGiftcards() {
    let memberCode;
    if (store.state.member) memberCode = store.state.member.MemberCode;

    if (store.state.menuDisabled || memberCode === undefined) {
      store.commit("giftcards", []);
      return true;
    } else {
      return mApp
        .apiPost(store.getters.dcApiUrl + "/giftcard", {
          sessionKey: store.getters.serviceSessionKey,
          list: [{ MemberCode: memberCode }],
        })
        .then(data => {
          if (data.list) {
            let listData = data.list[0];
            if (listData.result == "ok") {
              store.commit("giftcards", listData.record == null ? [] : listData.record);
              return true;
            } else {
              store.commit("giftcards", []);
              return false;
            }
          } else throw new Error(data.message || data.result || "Unknown error");
        })
        .catch(error => {
          console.log(error);
          store.commit("giftcards", []);
          return false;
        });
    }
  },

  linkGiftcard(payload) {
    let memberCode;
    let cardCode;
    let securityCode;
    if (store.state.member) memberCode = store.state.member.MemberCode;
    if (payload) cardCode = payload.cardCode;
    if (payload) securityCode = payload.securityCode;

    if (memberCode && cardCode && securityCode) {
      return mApp.apiPost(store.getters.dcApiUrl + "/giftcard", {
        sessionKey: store.getters.serviceSessionKey,
        put: { CardCode: cardCode, MemberCode: memberCode, CardSecurityCode: securityCode },
      });
    } else {
      return new Promise(function (resolve) {
        resolve({ put: { result: "Missing information" } });
      });
    }
  },

  // point
  addPointTrans(payload) {
    let memberCode = payload?.memberCode;
    let remark = payload?.remark;
    let points = payload?.points;

    if (!memberCode) {
      if (store.state.member) memberCode = store.state.member.MemberCode;
    }

    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberpointtrans", {
        sessionKey: store.getters.serviceSessionKey,
        add: { MemberCode: memberCode, Remark: remark, Amount: points },
      })
      .then(data => {
        let n_data = data;
        if (!n_data?.add) {
          n_data.add = { result: "Unknow error" };
        }
        if (n_data?.add?.result == "ok") {
          store.state.member.MemberPointBalance = data.add.Balance;
        }
        return n_data.add;
      });
  },

  getMemberAvailablePoints(memberCode, amount) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberpointtrans", {
        sessionKey: store.getters.serviceSessionKey,
        avail: { MemberCode: memberCode, Amount: amount },
      })
      .then(data => {
        return data?.avail;
      });
  },

  getMemberPointTrans(memberCode, pointType) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberpointtrans", {
        sessionKey: store.getters.serviceSessionKey,
        list: [{ MemberCode: memberCode, ForBalance: pointType, RecLimit: 250 }],
        points: pointType ? undefined : { MemberCode: memberCode },
      })
      .then(resp => {
        let memberData = resp.list[0];
        return { result: memberData?.result, points: memberData?.record, expiryPoints: resp.points?.data };
      });
  },

  async calculateCashToPoint(payload) {
    let amount = 0;
    if (payload?.amount == null) amount = store.state.Order.order.total;
    else amount = payload.amount;

    let points = 0;
    let cash = 0;
    if (amount > 0) {
      let resp = await mApp.apiPost(store.getters.doApiUrl + "/v2/calculatecashtopoints", {
        sessionKey: store.state.Store.store.sessionKey,
        amount: amount,
      });

      if (resp?.result == "ok") {
        points = resp.points;
        cash = resp.cash;
      }
    }

    return new Promise(function (resolve) {
      resolve({ points: points, cash: cash });
    });
  },

  redeemMemberPoints(memberCode, points) {
    let serviceSessionKey;
    if (store.state.Store.store && store.state.Store.store.service) {
      serviceSessionKey = store.state.Store.store.service.sessionKey;
    } else serviceSessionKey = store.getters.serviceSessionKey;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/memberpointtrans", {
        sessionKey: serviceSessionKey,
        add: [{ MemberCode: memberCode, Amount: -points, Remark: "Redeem" }],
      })
      .then(resp => {
        return resp.add[0];
      });
  },

  // promotion
  updateMemberPromos(memberCode, companyCode) {
    return new Promise(resolve => {
      this.getMemberPromos(memberCode, companyCode).then(promos => {
        store.commit("promos", promos);
        resolve(true);
      });
    });
  },

  getMemberPromos(memberCode, companyCode) {
    if (memberCode == "") memberCode = undefined;

    if (companyCode == null && store.state.Store.store) {
      companyCode = store.state.Store.store.companyCode;
    }

    return new Promise(resolve => {
      if (
        store.state.serverBuildNo >= 167 ||
        Vue.prototype.$appMode == APP_MODE.APP ||
        Vue.prototype.$appMode == APP_MODE.KIOSK
      ) {
        mApp
          .apiPost(store.getters.dcApiUrl + "/promo", {
            sessionKey: store.getters.serviceSessionKey,
            get: { MemberCode: memberCode, Store: companyCode, appName: store.getters.appName, Language: "all" },
          })
          .then(resp => {
            let result = resp?.get?.result;
            if (result == "ok") {
              let promos = resp.get.record;
              promos.forEach(promo => {
                this.addExInfoToPromo(promo);
              });

              resolve(promos);
            } else resolve([]);
          })
          .catch(error => {
            console.log(error);
            resolve([]);
          });
      } else {
        resolve([]);
      }
    });
  },

  getMemberPromo(memberCode, promoCode) {
    let n_store = undefined;
    if (n_store === undefined && store.state.Store.store) n_store = store.state.Store.store.companyCode;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/promo", {
        sessionKey: store.getters.serviceSessionKey,
        get: {
          MemberCode: memberCode,
          Store: n_store,
          PromoteCode: promoCode,
          Language: "all",
        },
      })
      .then(resp => {
        return resp.get;
      });
  },

  redeemMemberPromo(memberCode, promo) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/promo", {
        sessionKey: store.getters.serviceSessionKey,
        redeem: { MemberCode: memberCode, PromoteCode: promo.PromoteCode },
      })
      .then(resp => {
        return resp.redeem;
      });
  },

  addExInfoToPromo(promo) {
    if (promo == null) return;

    let title = promo.Titles.def;
    let title1 = title;
    let title2 = title;
    let detail = promo.Descriptions.def;
    let detail1 = detail;
    let detail2 = detail;

    store.getters.languages.forEach(lang => {
      let promoLangTitle = promo.Titles[lang.locale];
      if (promoLangTitle) {
        if (lang.descrIndex == 0) title = promoLangTitle;
        else if (lang.descrIndex == 1) title1 = promoLangTitle;
        else if (lang.descrIndex == 2) title2 = promoLangTitle;
      }

      let promoLangDetail = promo.Descriptions[lang.locale];
      if (promoLangDetail) {
        if (lang.descrIndex == 0) detail = promoLangDetail;
        else if (lang.descrIndex == 1) detail1 = promoLangDetail;
        else if (lang.descrIndex == 2) detail2 = promoLangDetail;
      }
    });

    Vue.set(promo, "title", title);
    Vue.set(promo, "title1", title1);
    Vue.set(promo, "title2", title2);
    Vue.set(promo, "detail", detail);
    Vue.set(promo, "detail1", detail1);
    Vue.set(promo, "detail2", detail2);
  },
};
